import { render, staticRenderFns } from "./AllCourseSearchCards.vue?vue&type=template&id=8656a9e8&scoped=true&"
import script from "./AllCourseSearchCards.vue?vue&type=script&lang=ts&"
export * from "./AllCourseSearchCards.vue?vue&type=script&lang=ts&"
import style0 from "./AllCourseSearchCards.vue?vue&type=style&index=0&id=8656a9e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8656a9e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8656a9e8', component.options)
    } else {
      api.reload('8656a9e8', component.options)
    }
    module.hot.accept("./AllCourseSearchCards.vue?vue&type=template&id=8656a9e8&scoped=true&", function () {
      api.rerender('8656a9e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/search/AllCourseSearchCards.vue"
export default component.exports